export const translation = {
  // SEO & Meta
  siteName: 'CSSBuy Spreadsheet',
  siteDescription: 'Find the CSSBuy Spreadsheet, buying guides, QC information, warehouse, shipping, coupons and reviews.',
  title: 'CSSBuy Spreadsheet 2026: Guides, Deals, QC & Shipping',
  metaDescription: 'Find the CSSBuy Spreadsheet, buying guides, information about QC, warehouse, shipping, coupons and reviews. Compare options and find updated resources for your purchases.',
  
  // Navigation
  navHome: 'Home',
  navGuide: 'Guide',
  navReview: 'Review',
  navShipping: 'Shipping',
  navCoupon: 'Coupon',
  navWarehouse: 'Warehouse',
  navSafety: 'Safety',
  navFAQ: 'FAQ',
  navAbout: 'About',
  navContact: 'Contact',
  navArticle: 'Article',
  navShoppingGuide: 'Shopping Guide',
  navGuides: 'Guides',
  
  // Language
  language: 'Language',
  pt: 'Português',
  de: 'Deutsch',
  en: 'English',
  
  // Categories
  categoriesTitle: 'Categories',
  categoriesDropdown: 'Select Category',
  shoes: 'Shoes',
  hoodiesSweaters: 'Hoodies/Sweaters',
  tShirts: 'T-Shirts',
  jackets: 'Jackets',
  pantsShorts: 'Pants/Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear/Underpants',
  jersey: 'Jersey',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  otherStuff: 'Other Stuff',
  
  // Hero
  heroH1: 'CSSBuy Spreadsheet: Find Products, Guides & Information in One Place',
  heroSubtitle: 'Explore the CSSBuy Spreadsheet, discover products, compare information and learn how to use CSSBuy more safely and efficiently.',
  heroCtaPrimary: 'Explore CSSBuy Spreadsheet',
  heroCtaSecondary: 'View Complete Guide',
  heroTrust: 'Independent information • Updated guides • Organized resources',
  heroDisclaimer: 'This site is an independent resource and does not officially represent CSSBuy.',
  
  // What is
  whatIsTitle: 'What is CSSBuy Spreadsheet?',
  whatIsH2: 'CSSBuy Spreadsheet: Everything you need to research better',
  whatIsDesc: 'The CSSBuy Spreadsheet is a practical way to organize and find information related to products, categories, links and resources used by buyers. Use organized resources to compare options and research more efficiently.',
  whatIsWarning: 'Before buying, always confirm the current link, seller, price, availability, QC and shipping conditions.',
  whatIsCta: 'Explore the CSSBuy Spreadsheet →',
  
  // Why Use
  whyUseTitle: 'Why use CSSBuy Spreadsheet?',
  whyUseH2: 'A simple place to research, compare and learn',
  whyFindTitle: 'Find quickly',
  whyFindDesc: 'Search categories and resources related to the CSSBuy Spreadsheet.',
  whyCompareTitle: 'Compare options',
  whyCompareDesc: 'Compare products and information in organized tables.',
  whyShippingTitle: 'Understand shipping',
  whyShippingDesc: 'Learn about weight, shipping and consolidation.',
  whyQCTitle: 'Check QC',
  whyQCDesc: 'Learn to analyze quality control photos.',
  whySafetyTitle: 'Buy with more information',
  whySafetyDesc: 'Consult safety resources before buying.',
  
  // Commercial Cards
  commercialTitle: 'CSSBuy Resources',
  reviewTitle: 'CSSBuy Review',
  reviewDesc: 'Independent analysis of features, experience, advantages and points of attention.',
  reviewCta: 'Read CSSBuy Review →',
  shippingCostTitle: 'CSSBuy Shipping Cost',
  shippingCostDesc: 'Understand the main factors that influence shipping costs.',
  shippingCostCta: 'View Shipping Cost Guide →',
  couponTitle: 'CSSBuy Coupon',
  couponDesc: 'Information about current coupons and promotions.',
  couponCta: 'View Coupon Guide →',
  discountCodeTitle: 'CSSBuy Discount Code',
  discountCodeDesc: 'How to verify discount codes and promotions.',
  discountCodeCta: 'View Discount Code Guide →',
  warehouseTitle: 'CSSBuy Warehouse',
  warehouseDesc: 'Information about storage, QC and preparation.',
  warehouseCta: 'View Warehouse Guide →',
  legitTitle: 'Is CSSBuy Legit?',
  legitDesc: 'Safety and verification information.',
  legitCta: 'Read CSSBuy Legit Guide →',
  
  // Comparison
  comparisonTitle: 'Compare before buying',
  comparisonH2: 'CSSBuy Spreadsheet: Compare before buying',
  comparisonFeature: 'Feature',
  comparisonCssbuy: 'CSSBuy',
  comparisonAlternative: 'Alternative',
  comparisonProductResearch: 'Product Research',
  comparisonSpreadsheetResources: 'Spreadsheet Resources',
  comparisonQCInfo: 'QC Information',
  comparisonShippingGuide: 'Shipping Guide',
  comparisonWarehouseGuide: 'Warehouse Guide',
  comparisonSafetyGuide: 'Safety Guide',
  comparisonYes: '✓',
  
  // FAQ
  faqTitle: 'FAQ',
  faqH2: 'CSSBuy Spreadsheet FAQ',
  faq1Q: 'What is CSSBuy Spreadsheet?',
  faq1A: 'CSSBuy Spreadsheet is a resource organization tool for buyers to research products and categories in a structured way.',
  faq2Q: 'How does CSSBuy Spreadsheet work?',
  faq2A: 'It organizes links, categories and information in an accessible format to facilitate product research.',
  faq3Q: 'How do I use CSSBuy Spreadsheet?',
  faq3A: 'Navigate through categories, check the links and always verify the seller and QC before buying.',
  faq4Q: 'Is CSSBuy legit?',
  faq4A: 'CSSBuy is a known buying agent. Always verify links and sellers before buying.',
  faq5Q: 'Is CSSBuy safe?',
  faq5A: 'Follow security practices: verify domains, links, QC and never share passwords.',
  faq6Q: 'How much does CSSBuy shipping cost?',
  faq6A: 'Cost depends on weight, dimensions, shipping line and destination. Use guides to estimate.',
  faq7Q: 'Does CSSBuy have coupons?',
  faq7A: 'Coupons and discount codes may be available. Check official and updated sources.',
  faq8Q: 'What is the CSSBuy discount code?',
  faq8A: 'Discount codes vary. Always verify validity and trusted sources.',
  faq9Q: 'How does CSSBuy warehouse work?',
  faq9A: 'The warehouse receives, inspects and prepares packages for shipping. Consult guides for details.',
  faq10Q: 'What is CSSBuy QC?',
  faq10A: 'QC (Quality Control) are inspection photos of the product before shipping.',
  
  // Final CTA
  finalCtaTitle: 'Ready to explore the CSSBuy Spreadsheet?',
  finalCtaDesc: 'Find guides, resources, comparisons and useful information to research better.',
  finalCtaPrimary: 'Explore CSSBuy Spreadsheet →',
  finalCtaSecondary: 'Visit Complete Guide →',
  
  // Buttons
  cssbuySpreadsheet: 'CSSBuy Spreadsheet',
  buyItNow: 'Buy it now',
  exploreNow: 'Explore Now',
  readMore: 'Read More',
  viewGuide: 'View Guide',
  
  // Footer
  footerDisclaimer: 'cssbuybr.surf is an independent informational resource. CSSBuy names, trademarks and third-party services belong to their respective owners.',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerDisclaimerLink: 'Disclaimer',
  footerContact: 'Contact',
  
  // Article Page
  articleTitle: 'CSSBuy Spreadsheet: Complete Guide 2026',
  articleH1: 'CSSBuy Spreadsheet – Complete Guide',
  articleBackToHome: '← Back to Home',
  articleMeta: 'Published on August 26, 2026 • Updated on August 26, 2026',
  articleAuthor: 'Author: CSSBuy Resource Team',
  
  // Article Sections
  articleToc: 'Contents',
  articleWhatIs: 'What is CSSBuy Spreadsheet?',
  articleHowWorks: 'How does CSSBuy Spreadsheet work?',
  articleFindProducts: 'How to find products',
  articleReadSpreadsheet: 'How to read a spreadsheet',
  articleCategories: 'Product categories',
  articleSellerInfo: 'Seller information',
  articleQC: 'QC (Quality Control)',
  articleWarehouse: 'Warehouse',
  articleShipping: 'Shipping',
  articleSafety: 'Safety',
  articleMistakes: 'Common mistakes',
  articleComparison: 'Comparison',
  articleFAQ: 'FAQ',
  
  // Safety Page
  safetyH1: 'CSSBuy Safety Guide',
  safetyVerifyDomain: 'Verify domain',
  safetyVerifyLinks: 'Verify product links',
  safetyCheckSeller: 'Check seller',
  safetyReviewQC: 'Review QC',
  safetyConfirmPrice: 'Confirm price',
  safetyConfirmShipping: 'Confirm shipping fee',
  safetyNeverSharePassword: 'Never share passwords',
  safetyAvoidPayment: 'Avoid suspicious payment requests',
  safetyVerifyCoupons: 'Verify coupons',
  safetyCheckPolicies: 'Check current policies',
  safetyBewareFake: 'Beware of fake websites',
  
  // Announcement
  announcement: 'Independent resource • Not the official CSSBuy website',
  
  // Breadcrumb
  breadcrumbHome: 'Home',
  breadcrumbArticle: 'Article',
  
  // Schema / Meta
  metaKeywords: 'CSSBuy Spreadsheet, CSSBuy Review, CSSBuy Shipping, CSSBuy Coupon, CSSBuy Discount Code, CSSBuy Warehouse, CSSBuy Legit, CSSBuy QC',
  ogTitle: 'CSSBuy Spreadsheet 2026: Guides, Deals, QC & Shipping',
  ogDescription: 'Find the CSSBuy Spreadsheet, buying guides, information about QC, warehouse, shipping, coupons and reviews.',
  
  // Related Articles
  relatedArticles: 'Related Articles',
  relatedReview: 'CSSBuy Review 2026',
  relatedShipping: 'CSSBuy Shipping Cost Guide',
  relatedCoupon: 'CSSBuy Coupon Guide',
  relatedWarehouse: 'CSSBuy Warehouse Guide',
  relatedLegit: 'Is CSSBuy Legit?',
  relatedQC: 'CSSBuy QC Guide',
  
  // Internal Link Anchors
  linkSpreadsheet: 'CSSBuy Spreadsheet',
  linkSpreadsheetGuide: 'CSSBuy spreadsheet guide',
  linkSpreadsheetResources: 'spreadsheet resources',
  linkBuyingGuide: 'CSSBuy buying guide',
  linkQCGuide: 'CSSBuy QC guide',
  linkShippingGuide: 'CSSBuy shipping guide',
  linkSafetyGuide: 'CSSBuy safety guide',
  
  // Product category cards on homepage
  productCategoriesTitle: 'Popular Categories',
  productCategoriesDesc: 'Explore the top CSSBuy Spreadsheet categories',
  
  // Latest Guides
  latestGuidesTitle: 'Latest Guides',
  latestGuidesDesc: 'Updated guides about CSSBuy',
  pillarSectionLabel: 'In-Depth Guides',
  pillarSectionTitle: 'CSSBuy Pillar Guides',
  pillarSectionDesc: 'Explore our complete collection of in-depth CSSBuy guides covering every stage of your buying journey.',
  
  // Product showcase
  allProducts: 'All Products',
  productsSectionLabel: 'Product Catalog',
  productsSectionTitle: 'Featured Products from CSSBuy Spreadsheet',
  productsSectionDesc: 'Browse our curated selection of products. Click any item to view details and purchase on kaspreadsheet.com.',
  buyNow: 'Buy Now',
  loadMore: 'Load More Products',
  showingCount: 'Showing {{visible}} of {{total}} products',
  trustIndependent: 'Independent information',
  trustUpdated: 'Updated guides',
  trustOrganized: 'Organized resources',
};

export default translation;